import { matchPath, resolvePath } from 'react-router-dom';
/** Finds a route definition that matches a given path */
export function findRouteMatch(urlPath, routes, rootPaths) {
    for (const rootPath of rootPaths) {
        const result = routes
            .filter((route) => route.path)
            .find((route) => findMatch(rootPath, route.path, urlPath)); // eslint-disable-line @typescript-eslint/no-non-null-assertion
        if (result) {
            return result;
        }
    }
}
function findMatch(pathBase, routePath, fullUrl) {
    const resolvedPath = resolvePath(routePath, pathBase);
    const match = matchPath(resolvedPath.pathname, fullUrl);
    return match;
}
